import { useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Button,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { IOSSwitch } from '../IOSSwitch';

interface RouterIperfServerEditProps {
  onSubmit: () => void;
  cpeId: string;
  iPerfServerEnabled: boolean;
}
export const RouterIperfServerEdit = ({ onSubmit, cpeId, iPerfServerEnabled }: RouterIperfServerEditProps) => {
  const api = useApi();
  const [newIperfServerEnabled, setNewIperfServerEnabled] = useState<boolean>(iPerfServerEnabled);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewIperfServerEnabled(e.target.checked);
    setDisableSubmit(e.target.checked === iPerfServerEnabled);
  };

  const toggleIperfServer = useMutation(api.configureIperfServerApiV1ConfigureIperfServerPost, {
    onSuccess() {
      toast.success(`${newIperfServerEnabled ? 'Enabled' : 'Disabled'} iPerf server successfully.`);
      onSubmit();
    },
    onError: (error) => {
      apiError(error);
      setDisableSubmit(false);
    },
  });

  const handleSubmit = () => {
    setDisableSubmit(true);
    toggleIperfServer.mutate({
      cpe_id: cpeId,
      enable: newIperfServerEnabled || false
    });
  };

  return (
    <Box pt={2}>
      <Typography variant="body1" sx={{ mb: 6 }}>
	      Enable or disable iPerf server for performance testing
      </Typography>
      <Box display="flex" justifyContent="center" sx={{ mb: 4 }}>
        <FormControlLabel
          value="top"
          control={
            <IOSSwitch color="primary" checked={newIperfServerEnabled} onChange={handleChange} />
          }
          label={newIperfServerEnabled ? 'Enabled' : 'Disabled'}
          labelPlacement="bottom"
          sx={(theme) => ({ '&:hover': { color: theme.palette.primary.main } })}
          componentsProps={{
            typography: {
              sx: (theme) => ({
                fontSize: 12,
                color: !newIperfServerEnabled ? theme.palette.grey[600] : theme.palette.primary.main,
              }),
            },
          }}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={disableSubmit}>
          Confirm
        </Button>
      </Box>
    </Box>
  );
};
